<template>
  <v-app>
    <app-top-bar :show-help-button="false" path-return="HELP">
      {{ $t('helpCentral.pageTitle') }}
    </app-top-bar>
    <v-main>
      <v-container>
        <v-sheet class="ma-0 pa-0 px-2 d-flex flex-row justify-space-between flex-wrap px-2 bg-background">
          <v-btn
            v-for="btn in buttons"
            :key="btn.text"
            class="white btn my-2 pa-2 flex-grow-0"
            color="primary"
            :min-height="btnHeight"
            variant="text"
            @click="onClickItem(btn.content)"
          >
            <v-sheet class="text-center" color="transparent">
              <v-img class="mb-3" contain max-height="40px" :src="btn.icon" />
              <span>{{ btn.text }}</span>
            </v-sheet>
          </v-btn>
        </v-sheet>

        <v-dialog v-model="contentDialog" persistent>
          <v-card class="py-4 px-8 d-flex flex-column align-center bg-background text-on-surface-variant">
            <component :is="currentComponent" />
            <v-btn class="bottom-btn mt-8" color="primary" large @click="onCloseContent">
              {{ $t('helpCentral.understoodButton') }}
            </v-btn>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>

    <app-footer>
      <footer-button color="primary" @click="report">
        {{ $t('helpCentral.reportButton') }}
      </footer-button>
    </app-footer>
  </v-app>
</template>

<script setup>
import { useUtils } from '@/composables/useUtils'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

import HelpClaim from '@/components/HelpClaim/HelpClaim.vue'
import HelpCoverage from '@/components/HelpCoverage/HelpCoverage.vue'
import HelpDetails from '@/components/HelpDetails/HelpDetails.vue'
import HelpFAQ from '@/components/HelpFAQ/HelpFAQ.vue'
import HelpSafety from '@/components/HelpSafety/HelpSafety.vue'

import bulb from '@/assets/images/bulb.svg'
import handup from '@/assets/images/handup.svg'
import shield from '@/assets/images/shield.svg'
import siren from '@/assets/images/siren.svg'
import tools from '@/assets/images/tools.svg'
import whatsapp from '@/assets/images/whatsapp.svg'

const util = useUtils()

const contentDialog = ref(false)
const currentComponent = ref(null)
const btnHeight = ref('0px')

const onClickItem = content => {
  if (typeof content === 'function') return content()

  currentComponent.value = content
  contentDialog.value = true
}

const onCloseContent = () => {
  contentDialog.value = false
  currentComponent.value = null
}

const report = () => {
  util.openBikeHeroWhatsApp()
}

const buttons = [
  {
    icon: shield,
    text: t('helpCentral.coverageText'),
    content: HelpCoverage,
  },
  {
    icon: bulb,
    text: t('helpCentral.safetyText'),
    content: HelpSafety,
  },
  {
    icon: tools,
    text: t('helpCentral.detailsText'),
    content: HelpDetails,
  },
  {
    icon: handup,
    text: t('helpCentral.faqText'),
    content: HelpFAQ,
  },
  {
    icon: siren,
    text: t('helpCentral.claimText'),
    content: HelpClaim,
  },
  {
    icon: whatsapp,
    text: t('helpCentral.whatsappText'),
    content: report,
  },
]

onMounted(() => {
  btnHeight.value = document.getElementsByClassName('btn')[0].offsetWidth + 'px'
})
</script>

<style scoped>
.btn {
  width: 45%;
}
:deep(.v-btn__content) {
  max-width: 100%;
  white-space: normal;
}
</style>
